import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import ToolForm from "../form";

const UpdateTool = () => {
  const { toolId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Tool" />
      <div className="p-6 max-w-2xl">
        <ToolForm toolId={toolId} />
      </div>
    </div>
  );
};

export default UpdateTool;
